<div class="relative inline-flex flex-col items-center">
	<!-- Main Avatar Circle -->
	<div class="relative group cursor-default transform transition-transform hover:scale-105 duration-300">
		<div
			class="rounded-full flex items-center justify-center shadow-md transition-colors duration-500 ease-in-out"
			[style.width.px]="sizeStyles().circlePx"
			[style.height.px]="sizeStyles().circlePx"
			[style.borderWidth.px]="sizeStyles().borderPx"
			[style.borderColor]="'white'"
			[style.borderStyle]="'solid'"
			[style.backgroundColor]="avatarColor()">
			<span
				class="text-white font-bold tracking-tight select-none"
				[style.fontSize.px]="sizeStyles().fontPx">
				{{ initials() }}
			</span>
		</div>

		<!-- Role Icon Badge -->
		<div
			class="absolute bottom-0 right-0 bg-white rounded-full flex items-center justify-center shadow border border-slate-100 transition-colors duration-500"
			[style.width.px]="sizeStyles().badgePx"
			[style.height.px]="sizeStyles().badgePx"
			[style.color]="avatarColor()">
			@switch (role()) {
				@case ("physician") {
					<svg
						[style.width.px]="sizeStyles().badgeIconPx"
						[style.height.px]="sizeStyles().badgeIconPx"
						viewBox="0 0 24 24"
						fill="none"
						stroke="currentColor"
						stroke-width="2"
						stroke-linecap="round"
						stroke-linejoin="round">
						<path
							d="M4.8 2.3A.3.3 0 1 0 5 2H4a2 2 0 0 0-2 2v5a6 6 0 0 0 6 6v0a6 6 0 0 0 6-6V4a2 2 0 0 0-2-2h-1a.2.2 0 1 0 .3.3" />
						<path d="M8 15v1a6 6 0 0 0 6 6v0a6 6 0 0 0 6-6v-4" />
						<circle
							cx="20"
							cy="10"
							r="2" />
					</svg>
				}
				@case ("nurse") {
					<svg
						[style.width.px]="sizeStyles().badgeIconPx"
						[style.height.px]="sizeStyles().badgeIconPx"
						viewBox="0 0 24 24"
						fill="none"
						stroke="currentColor"
						stroke-width="2"
						stroke-linecap="round"
						stroke-linejoin="round">
						<path
							d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
						<path d="M3.22 12H9.5l.5-1 2 4.5 2-7 1.5 3.5h5.27" />
					</svg>
				}
				@case ("midwife") {
					<svg
						[style.width.px]="sizeStyles().badgeIconPx"
						[style.height.px]="sizeStyles().badgeIconPx"
						viewBox="0 0 24 24"
						fill="none"
						stroke="currentColor"
						stroke-width="2"
						stroke-linecap="round"
						stroke-linejoin="round">
						<path d="M9 12h.01" />
						<path d="M15 12h.01" />
						<path d="M10 16c.5.3 1.2.5 2 .5s1.5-.2 2-.5" />
						<path
							d="M19 6.3a9 9 0 0 1 1.8 3.9 2 2 0 0 1 0 3.6 9 9 0 0 1-17.6 0 2 2 0 0 1 0-3.6A9 9 0 0 1 12 3c2 0 3.5 1.1 3.5 2.5s-.9 1.5-2 1.5c-2.5 0-3 2-3 2" />
					</svg>
				}
				@case ("engineer") {
					<svg
						[style.width.px]="sizeStyles().badgeIconPx"
						[style.height.px]="sizeStyles().badgeIconPx"
						viewBox="0 0 24 24"
						fill="none"
						stroke="currentColor"
						stroke-width="2"
						stroke-linecap="round"
						stroke-linejoin="round">
						<path
							d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
					</svg>
				}
				@case ("admin") {
					<svg
						[style.width.px]="sizeStyles().badgeIconPx"
						[style.height.px]="sizeStyles().badgeIconPx"
						viewBox="0 0 24 24"
						fill="none"
						stroke="currentColor"
						stroke-width="2"
						stroke-linecap="round"
						stroke-linejoin="round">
						<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
						<path d="m9 12 2 2 4-4" />
					</svg>
				}
				@default {
					<svg
						[style.width.px]="sizeStyles().badgeIconPx"
						[style.height.px]="sizeStyles().badgeIconPx"
						viewBox="0 0 24 24"
						fill="none"
						stroke="currentColor"
						stroke-width="2"
						stroke-linecap="round"
						stroke-linejoin="round">
						<path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" />
						<circle
							cx="12"
							cy="7"
							r="4" />
					</svg>
				}
			}
		</div>
	</div>

	@if (showCaption) {
		<!-- Name / Role caption -->
		<div class="mt-2 text-center leading-tight">
			<p class="text-sm font-semibold text-slate-800">
				{{ firstName() || "Unknown" }} {{ lastName() || "User" }}
			</p>
			<p class="text-xs text-slate-500 capitalize">{{ jobLabel() || role() }}</p>
		</div>
	}
</div>
